export default "__VITE_ASSET__CHA9BK6u__"